import { Box, Divider } from '@chakra-ui/react';
import { MdOutlineKeyboardArrowUp } from 'react-icons/md';

import UserInfo from './UserInfo';
import AccordionHeader from './AccordianHeader';
import EmailInfo from './EmailInfo';
import MobileInfo from './PhoneNumbersInfo';
import SocialInfo from './SocialInfo';
import Statuses from './Statuses';

const ContactInfo = () => {
  return (
    <Box
      width="100%"
      height="83.5vh"
      overflowY="auto"
      borderRadius="md"
      css={{
        '&::-webkit-scrollbar': {
          width: '4px',
          height: '20vh',
        },
        '&::-webkit-scrollbar-track': {
          background: '#ffffff',
          borderRadius: '8px',
        },
        '&::-webkit-scrollbar-thumb': {
          background: '#E7B9B1',
          borderRadius: '8px',
        },
      }}
    >
      <Box>
        <UserInfo />

        <AccordionHeader
          name="CONTACT"
          icon={<MdOutlineKeyboardArrowUp fontSize={25} />}
        />
        <EmailInfo />
        <MobileInfo />
        <SocialInfo />
        <Divider
          orientation="vertical"
          height="10px"
          borderBottom="solid 1px orange"
        />

        {/* <AccordionHeader
          name="TAGS"
          icon={<MdOutlineKeyboardArrowUp fontSize={25} />}
        /> */}
        <Divider
          orientation="vertical"
          height="10px"
          borderBottom="solid 1px orange"
        />
        <AccordionHeader
          name="STATUS"
          icon={<MdOutlineKeyboardArrowUp fontSize={25} />}
        />
        <Statuses />
        {/* <Content2 /> */}
      </Box>
    </Box>
  );
};
export default ContactInfo;
